import React from 'react';
import { useSelector } from 'react-redux';

import { logger } from 'packages';
import useIsFeatureEnabled from 'tradera-hooks/use-is-feature-enabled';
import ApplicationErrorBoundary from 'tradera-components/application-error-boundary';
import LastChance from './last-chance/last-chance';
import Carousel from './carousel/carousel';
import InstagramFeed from './instagram-feed/instagram-feed';
import PopularCategories from './popular-categories/popular-categoires';
import { RecentlyViewed } from './recently-viewed/recently-viewed';
import PicksForYou from './picks-for-you/picks-for-you';
import {
    LAST_CHANCE,
    PICKS_FOR_YOU,
    POPULAR_CATEGORIES,
    CAROUSEL,
    RECENTLY_VIEWED,
    INSTAGRAM_FEED
} from './content-types';

const Container = ({ container, inSPA, videoEnabled }) => {
    const { type, data } = container;

    switch (type) {
        case LAST_CHANCE:
            return <LastChance inSPA={inSPA} />;
        case RECENTLY_VIEWED:
            return <RecentlyViewed />;
        case CAROUSEL:
            return (
                <Carousel
                    containerType={CAROUSEL}
                    data={data}
                    inSPA={inSPA}
                    videoEnabled={videoEnabled}
                />
            );
        case POPULAR_CATEGORIES:
            return (
                <PopularCategories
                    containerType={POPULAR_CATEGORIES}
                    data={data}
                    inSPA={inSPA}
                    videoEnabled={videoEnabled}
                />
            );
        case PICKS_FOR_YOU:
            return <PicksForYou />;
        case INSTAGRAM_FEED:
            return <InstagramFeed data={data} />;
        default:
            logger(`Unknown content type ${type}`);
            return (
                <h3 className="d-flex justify-content-center py-5 text-warning">
                    ({`Unkown content type ${type}`})
                </h3>
            );
    }
};

const PageContent = () => {
    const content = useSelector(state => state.views.startPage.config.content);
    const videoEnabled = useIsFeatureEnabled('start-page-contentful-video');
    const inSPA = useIsFeatureEnabled('spa');
    if (!content) {
        logger('Start page content missing');
        return (
            <h3 className="d-flex justify-content-center py-5 text-warning">
                Start page content missing!
            </h3>
        );
    }
    return content.map((container, index) => {
        return (
            <ApplicationErrorBoundary key={container.type + index}>
                <Container
                    container={container}
                    inSPA={inSPA}
                    videoEnabled={videoEnabled}
                />
            </ApplicationErrorBoundary>
        );
    });
};

export default PageContent;
